<div class="gl-dashboard__header">
  <div class="gl-dashboard__title">
    <span>{{ 'dashboard.widgets.metrics' | translate }}</span>
    <button
      type="button"
      lmsTooltip
      [tooltipConfig]="{
        positionV: 'top',
        positionH: 'center',
        text: ['dashboard.widgets.metricsTooltip' | translate]
      }"
      class="un-btn"
    >
      <span class="glicon-info"></span>
    </button>
  </div>
  <lms-select-dashboard
    [selectionList]="filterList"
    [defaultFilter]="defaultFilter"
    (selectedFilter)="setFilter($event)"
  ></lms-select-dashboard>
</div>
<div class="gl-dashboard__grid metric">
  <div>
    <div class="gl-dashboard__title small">{{ 'dashboard.widgets.applicability' | translate }}</div>
    <lms-chart-speedometer [showCircle]="true" [progress]="metric['ratioApplication']"></lms-chart-speedometer>
  </div>
  <div>
    <div class="gl-dashboard__title small">
      {{ 'dashboard.widgets.recommendation' | translate }}
    </div>
    <lms-chart-speedometer [showCircle]="true" [progress]="metric['ratioRecommendation']"></lms-chart-speedometer>
  </div>
  <div *ngIf="clientSubscriptionType === 'users'">
    <div class="gl-dashboard__title small">{{ 'dashboard.widgets.valuation' | translate }}</div>
    <lms-chart-speedometer
      [showCircle]="true"
      [showPercentage]="false"
      [showMedia]="true"
      [maxRange]="10"
      [progress]="metric['averageScore']"
    ></lms-chart-speedometer>
  </div>
  <div *ngIf="clientSubscriptionType === 'credits'">
    <div class="gl-dashboard__title small">
      {{ 'dashboard.widgets.finished' | translate }}
    </div>
    <lms-chart-speedometer [showCircle]="true" [progress]="metric['ratioFinished']"></lms-chart-speedometer>
  </div>
</div>
<div *ngIf="clientId" class="gl-dashboard__links metrics">
  <a
    class="gl-dashboard__links--item"
    [queryParams]="{ reportType: 'assessment', clientId: clientId }"
    [routerLink]="['/reports/surveys']"
  >
    <span>{{ 'nouns.viewReports' | translate }}</span>
    <span class="glicon-arrow-right"></span>
  </a>
</div>
